module.exports = __webpack_public_path__ + "assets/Kahu-tagline.4c625674.svg";